import React, { useState, useEffect } from 'react'
import Header from '../Header/Header'
import ChatInterface from '../ChatInterface/ChatInterface'
import ChatHistorySidebar from '../ChatHistorySidebar/ChatHistorySidebar'
import FlowVisualizer from '../FlowVisualizer/FlowVisualizer'
import StatusMessages from '../FlowVisualizer/StatusMessages'
import { useAppContext } from '../../context/AppContext'

const ChatApp = () => {
  const { state } = useAppContext()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  // Default to closed on mobile (768px and below), open on desktop
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
  const [chatHistoryOpen, setChatHistoryOpen] = useState(!isMobile)

  const toggleChatHistory = () => {
    setChatHistoryOpen(prev => !prev)
  }

  // Handle example query selection from welcome screen
  useEffect(() => {
    const handleExampleSelect = (event) => {
      const query = event.detail
      // Find the input field and set its value
      const inputField = document.querySelector('.input-field')
      if (inputField) {
        inputField.value = query
        inputField.focus()
        // Trigger input event to update React state
        const inputEvent = new Event('input', { bubbles: true })
        inputField.dispatchEvent(inputEvent)
      }
    }

    window.addEventListener('selectExample', handleExampleSelect)
    return () => window.removeEventListener('selectExample', handleExampleSelect)
  }, [])

  // Close sidebar on escape key
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && sidebarOpen) {
        setSidebarOpen(false)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [sidebarOpen])

  return (
    <div className="app">
      {/* Header with user settings */}
      <Header onToggleSidebar={toggleChatHistory} isSidebarOpen={chatHistoryOpen} />

      {/* Chat history sidebar with toggle button */}
      <ChatHistorySidebar
        isOpen={chatHistoryOpen}
        onToggle={toggleChatHistory}
      />

      {/* Main conversation area */}
      <div className={`conversation-container ${chatHistoryOpen ? 'with-history' : 'with-history collapsed'}`}>
        <ChatInterface />
      </div>

      {/* Flow visualizer - conditionally rendered */}
      {state.flowVisible && (
        <div className="flow-overlay">
          <FlowVisualizer />
        </div>
      )}

      {/* Global status messages */}
      <StatusMessages />

      {/* Overlay for mobile - for chat history sidebar */}
      {chatHistoryOpen && typeof window !== 'undefined' && window.innerWidth <= 768 && (
        <div
          className="chat-history-overlay"
          onClick={() => setChatHistoryOpen(false)}
        />
      )}

    </div>
  )
}

export default ChatApp
